import React from 'react'
import Button from '../form/Button'

import PlusIcon from '../../../assets/icons/plus.svg?react'
import MinusIcon from '../../../assets/icons/minus.svg?react'

type Props = { children: React.ReactNode | string, label: React.ReactNode | string, size?: 'sm' | 'md' | 'lg' }
const Collapsable: React.FC<Props> = ({ label, children, size }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  return (
    <div className='w-full py-1 my-3 shadow rounded-lg bg-white'>
      <Button size={size} variant='flat' onClick={() => setIsOpen(!isOpen)} className='w-full'>
        <div className='w-full text-start mx-4'>
          <span className='text-xs sm:text-sm flex justify-between items-center leading-none'>
            {label} {isOpen ?  <MinusIcon /> : <PlusIcon />}
          </span>
        </div>
      </Button>
      {isOpen && (
        <div className='py-4 mx-4 font-light border-t-soft-green border-t border-solid'>
          {children}
        </div>
      )}
    </div>
  )
}

export default Collapsable
